// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.model-upload-dialog-content {
  display: flex;
  flex-direction: column;
  gap: var(--dialog-element-gap);
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/model-upload-dialog/ModelUploadDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC","sourcesContent":[".model-upload-dialog-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dialog-element-gap);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
